import styled from "styled-components";
import Col from "../../UIcomponent/Column";

export const Layout = styled(Col)`
  svg {
    width: 350px;
  }
  @media screen and (max-width: 480px) {
    svg {
      width: 260px;
    }
  }
`;
